import { Autocomplete, Box, Button, FormControl, FormControlLabel, FormHelperText, FormLabel, IconButton, InputLabel, Link, MenuItem, Radio, RadioGroup, Select, Skeleton, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from './Settings.module.css';
import { useDispatch, useSelector } from "react-redux";
import { toggleLoader } from "../../Store/loader/loaderReducer";
import axios from "axios";
import { toast } from "react-toastify";
import moment from 'moment-timezone';
import TimeZones from "../../Utils/timeZone";
import { OrgNavigation } from "../../Utils/handleOrgNavigation";
import CloseIcon from '@mui/icons-material/Close';

const blog_label = { 1: { label: 'Wix API' }, 7: { label: 'Wordpress API' }, 9: { label: 'Wix' }, 10: { label: 'WordPress' } };
const Settings = () => {
    const [apiKey, setApiKey] = useState({ timezone: moment.tz.guess(), company_name: "", company_description: '', channel_type: '' });
    const [editApiKey, setEditApiKey] = useState(null);
    const [pageShow, setPageShow] = useState(false);
    const [toggle, setToggle] = useState([]);
    const [errors, setErrors] = useState({ timezone: false, company_name: false, company_description: false, css_file: false });
    const [loading, setLoading] = useState(false);
    const [cssFile, setCssFile] = useState(null);
    const [layoutEnabled, setLayoutEnabled] = useState(false);
    const [headerFile, setHeaderFile] = useState(null);
    const [footerFile, setFooterFile] = useState(null);

    const dispatch = useDispatch();
    const navPath = OrgNavigation();

    const org_info = useSelector((state) => state?.org_info?.value);
    const json_Features = JSON.parse(org_info.show_features);
    const FeaturesAllTypes = json_Features[0].features
    const features = FeaturesAllTypes.CENTILIO_INTEGRATION_SETTING === undefined ? true : FeaturesAllTypes.CENTILIO_INTEGRATION_SETTING;

    useEffect(() => {
        fetchSettings();
        if (org_info['blog_platform']?.length) setToggle(org_info['blog_platform']);
    }, []);

    const timeZoneOptions = Object.entries(TimeZones).map(([key, value]) => ({
        key,
        ...value,
    }));

    const fetchSettings = () => {
        axios.get(process.env.REACT_APP_SETTINGS, { withCredentials: process.env.REACT_APP_CREDENTIALS, params: { org_id: org_info?.default_organizations?.Id } })
            .then((res) => {
                dispatch(toggleLoader(false));
                setPageShow(true);
                let data = res.data.setting;
                let obj = { ...apiKey };
                const hasChannelType = org_info['blog_platform']?.length && org_info['blog_platform']?.some(item => item?.Channel_Type === data?.Channel_Type);
                if (data) {
                    obj['api_key'] = data?.Api_Key;
                    obj['member_id'] = data?.Member_Id;
                    obj['site_id'] = data?.Site_Id;
                    if (org_info['blog_platform']?.length && hasChannelType) obj['channel_type'] = data?.Channel_Type;
                    obj['company_name'] = data?.Company_Name;
                    obj['company_description'] = data?.Company_Description;
                    if (data?.timezone) {
                        const getTimeZone = timeZoneOptions.find((zone) => zone.key === data?.timezone);
                        obj['timezone'] = getTimeZone;
                    }
                    setApiKey(obj);
                    setEditApiKey(obj);
                };
            })
            .catch((err) => {
                const dynamicKey = Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
                const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details : null;
                toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
                dispatch(toggleLoader(false));
            });
    };


    const getEditInputField = (values) => {
        let old_obj = Object.keys(editApiKey)?.find(ele => values[ele] !== editApiKey[ele]);
        return old_obj;
    };

    const channelType = (e) => {
        axios.put(process.env.REACT_APP_SETTINGS, { channel_type: e, org_id: org_info?.default_organizations?.Id }, { withCredentials: process.env.REACT_APP_CREDENTIALS })
            .then((res) => {
                dispatch(toggleLoader(false));
            })
            .catch((err) => {
                dispatch(toggleLoader(false));
                const dynamicKey = Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
                const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details : null;
                toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
            });
    };

    const handlePost = () => {
        let params = { org_id: org_info?.default_organizations?.Id, company_name: apiKey?.company_name, timezone: apiKey?.timezone?.key };

        const newErrors = {
            timezone: !apiKey?.timezone?.key?.trim(),
            company_description: !apiKey?.company_description?.trim(),
            company_name: !apiKey?.company_name?.trim(),
            channel_type: !String(apiKey.channel_type).trim(),
            css_file: !cssFile
        };

        setErrors(newErrors);
        const hasError = Object.values(newErrors).some((error) => error);

        if (hasError) return;

        let edit_value = getEditInputField(apiKey);
        if (!edit_value) {
            toast.warning('No changes');
            return;
        };

        let update_value = {};
        Object.entries(editApiKey).forEach(([key, value]) => {
            if (value !== apiKey[key]) {
                if (key === 'timezone') update_value[key] = apiKey[key]?.key;
                else update_value[key] = apiKey[key];
            };
        });

        setLoading(true);
        dispatch(toggleLoader(true));
        if (update_value && Object.keys(update_value)?.length) {
            axios.put(process.env.REACT_APP_SETTINGS, { ...update_value, org_id: org_info?.default_organizations?.Id }, { withCredentials: process.env.REACT_APP_CREDENTIALS })
                .then((res) => {
                    dispatch(toggleLoader(false));
                    toast.success('Success');
                    setLoading(false);
                })
                .catch((err) => {
                    dispatch(toggleLoader(false));
                    setLoading(false);
                    const dynamicKey = Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
                    const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details: null;
                    toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
                });
        } else {
            axios.post(process.env.REACT_APP_SETTINGS, params, { withCredentials: process.env.REACT_APP_CREDENTIALS })
                .then((res) => {
                    dispatch(toggleLoader(false));
                    toast.success('Success');
                    setLoading(false);
                })
                .catch((err) => {
                    dispatch(toggleLoader(false));
                    setLoading(false);
                    if (err?.response?.data?.error?.message === 'duplicate_record') toast.error(err?.response?.data?.error?.details || "An unexpected error occurred. Please try again later.");
                    else {
                        const dynamicKey = Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
                        const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details : null;
                        toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
                    };
                });
        }
    };

    const handleNavigate = () => {
        navPath('/Integration');
    };

    return (
        <>
            {pageShow ?
                <Box>
                    <Box className={styles.header_title}>
                        <Box className={styles.title}>
                            <Box className={styles.header_text}>Settings</Box>
                        </Box>
                    </Box>
                    <Box className={styles.top_bar} >
                        <Box className={styles.main_wrap}>
                            <Box className={styles.settings_body}>
                                <Box className={styles.wix_setting}>Post Setting</Box>
                                <Box className={styles.wix_list} sx={{ padding: '20px' }}>
                                    <FormControl sx={{ display: 'flex', flexDirection: "row", alignItems: 'center' }} error={errors.channel_type}>
                                        <FormLabel id="demo-radio-buttons-group-label" className={styles.blog_label}>Blog Platform<span style={{ color: 'red' }}>*</span></FormLabel>
                                        {org_info['blog_platform']?.length ?
                                            <>
                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    value={apiKey?.channel_type}
                                                    name="radio-buttons-group"
                                                    sx={{ display: "flex", flexDirection: "row" }}
                                                    onChange={(e) => [setApiKey({ ...apiKey, channel_type: Number(e.target.value) }), setErrors({ ...errors, [errors?.channel_type]: false })]}
                                                >
                                                    {toggle?.map((item, i) => {
                                                        return (
                                                            ((features && item?.channel_type === 2) || item?.channel_type !== 2) && <FormControlLabel key={i} value={item?.Channel_Type} onClick={(e) => channelType(item?.Channel_Type)}
                                                                sx={{
                                                                    "& .MuiFormControlLabel-label": {
                                                                        fontSize: "14px",
                                                                        fontFamily: "var(--primary-font-family)",
                                                                        color: 'var(--table-font-color)'
                                                                    },
                                                                }}
                                                                control={<Radio sx={{ "& .MuiSvgIcon-root": { fontSize: 20 } }} />} label={item?.Channel_Type === 2 ? item?.App_Name : blog_label[item?.Channel_Type]?.label} />
                                                        )
                                                    })}
                                                </RadioGroup>
                                                {errors.channel_type && (
                                                    <FormHelperText>
                                                        Blog platform is required
                                                    </FormHelperText>
                                                )} </> :
                                            <><Box className={styles.not_connected_text}>No platform connected. Go to <Typography onClick={handleNavigate} sx={{ cursor: 'pointer', textDecoration: 'underline', color: 'var(--primary)', margin: '0px 5px', fontSize: '14px' }} >Integration tab</Typography> to connect to your platform</Box>
                                                {errors.channel_type && (
                                                    <FormHelperText>
                                                        Please Connect a channel
                                                    </FormHelperText>
                                                )}</>}

                                    </FormControl>
                                    <Box className={styles.file_post_container}>
                                        <InputLabel className={styles.post_label}>Company Name<span style={{ color: 'red' }}>*</span></InputLabel>
                                        <TextField
                                            multiline
                                            minRows={1}
                                            required
                                            className={styles.file_post_input}
                                            onChange={(e) => [setApiKey({ ...apiKey, company_name: e.target.value }), setErrors({ ...errors, [errors.company_name]: false })]}
                                            sx={{
                                                fieldset: { border: "1px solid #E6E7E9" },
                                                '& .MuiOutlinedInput-root': {
                                                    '&:hover fieldset': {
                                                        borderColor: 'var(--primary) !important',
                                                    },
                                                    '& fieldset.MuiOutlinedInput-notchedOutline': {
                                                        border: "1px solid #E6E7E9"
                                                    },
                                                    fontSize: '14px',
                                                    // paddingLeft: '2px',
                                                },
                                            }}
                                            value={apiKey?.company_name}
                                            placeholder='Enter Company Name'
                                            error={true}
                                            helperText={errors.company_name ? 'Company name is required' : ''}
                                        />
                                    </Box>
                                    <Box className={styles.file_post_container}>
                                        <InputLabel className={styles.post_label}>Company Description<span style={{ color: 'red' }}>*</span></InputLabel>
                                        <TextField
                                            multiline
                                            minRows={3}
                                            required
                                            maxRows={10}
                                            className={styles.file_post_input}
                                            onChange={(e) => [setApiKey({ ...apiKey, company_description: e.target.value }), setErrors({ ...errors, [errors.company_description]: false })]}
                                            sx={{
                                                fieldset: { border: "1px solid #E6E7E9" },
                                                '& .MuiOutlinedInput-root': {
                                                    '&:hover fieldset': {
                                                        borderColor: 'var(--primary) !important',
                                                    },
                                                    '& fieldset.MuiOutlinedInput-notchedOutline': {
                                                        border: "1px solid #E6E7E9"
                                                    },
                                                    fontSize: '14px',
                                                    // paddingLeft: '2px',
                                                },
                                            }}
                                            value={apiKey?.company_description}
                                            placeholder='Company Description'
                                            error={true}
                                            helperText={errors.company_description ? 'Description is required' : ''}
                                        />
                                    </Box>

                                    <Box className={styles.file_post_container}>
                                        <InputLabel className={styles.post_label}>Time Zone<span style={{ color: 'red' }}>*</span></InputLabel>
                                        <Autocomplete
                                            sx={{
                                                fieldset: { border: "1px solid #E6E7E9" },
                                                '&:hover': {
                                                    '&& fieldset': {
                                                        border: '1px solid var(--primary) !important',
                                                        outline: 0,
                                                    },
                                                },
                                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: '1px solid var(--primary) !important' },
                                                fontSize: '14px',
                                                "& .MuiInputBase-root": { height: "41.92px" },
                                                width: '85%',
                                            }}
                                            options={timeZoneOptions}
                                            required
                                            autoHighlight
                                            getOptionLabel={(option) => option?.display_text || ''}
                                            renderOption={(props, option) => {
                                                const { key, ...otherProps } = props;
                                                return (
                                                    <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 }, fontSize: '14px', fontFamily: 'var(--primary-font-family)' }} key={key} {...otherProps}>
                                                        {option?.display_text}
                                                    </Box>
                                                )
                                            }}
                                            onChange={(event, newValue) => [
                                                setApiKey({ ...apiKey, timezone: newValue }),
                                                setErrors({ ...errors, [errors.timezone]: false })
                                            ]}
                                            isOptionEqualToValue={(option, value) => option.key === value.key}
                                            value={apiKey?.timezone}
                                            renderInput={(params) => (
                                                <TextField
                                                    sx={{ "& .MuiInputBase-root": { height: "41.92px", padding: '0px 0px 0px 10px !important', fontSize: '14px' } }}
                                                    {...params}
                                                    inputProps={{
                                                        ...params.inputProps,
                                                        autoComplete: 'new-password'
                                                    }}
                                                    error={errors?.timezone}
                                                    helperText={errors.timezone ? 'Time zone is required' : ''}
                                                />
                                            )}
                                        />
                                    </Box>

                                    <Box className={styles.file_post_container}>
                                        <InputLabel className={styles.post_label}>CSS file<span style={{ color: 'red' }}>*</span></InputLabel>
                                        <Box sx={{ width: '85%' }}>
                                            <Box
                                                sx={{
                                                    border: errors.css_file ? '1px solid #d32f2f' : '1px solid #E6E7E9',
                                                    borderRadius: '4px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    overflow: 'hidden',
                                                    position: 'relative',
                                                    '&:hover': {
                                                        borderColor: errors.css_file ? '#d32f2f' : 'var(--primary)',
                                                    }
                                                }}
                                            >
                                                <Button
                                                    component="label"
                                                    sx={{
                                                        textTransform: 'none',
                                                        borderRadius: 0,
                                                        backgroundColor: '#f0f7ff',
                                                        color: '#1976d2',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        padding: '8px 16px',
                                                        minWidth: 'auto',
                                                        '&:hover': {
                                                            backgroundColor: '#e3f2fd',
                                                        }
                                                    }}
                                                >
                                                    Choose File
                                                    <input
                                                        type="file"
                                                        hidden
                                                        accept=".css"
                                                        onChange={(e) => {
                                                            setCssFile(e.target.files[0]);
                                                            setErrors({ ...errors, css_file: false });
                                                        }}
                                                    />
                                                </Button>
                                                <Typography sx={{ px: 2, fontSize: '14px', color: '#666', flex: 1 }}>
                                                    {cssFile ? cssFile.name : 'No file chosen'}
                                                </Typography>
                                                {cssFile && (
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => setCssFile(null)}
                                                        sx={{
                                                            marginRight: '8px',
                                                            padding: '4px',
                                                            '&:hover': {
                                                                backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                                            }
                                                        }}
                                                    >
                                                        <CloseIcon sx={{ fontSize: '18px', color: '#666' }} />
                                                    </IconButton>
                                                )}
                                            </Box>
                                            {errors.css_file && (
                                                <FormHelperText error sx={{ marginLeft: '14px', marginTop: '4px' }}>
                                                    CSS file is required
                                                </FormHelperText>
                                            )}
                                        </Box>
                                    </Box>
                                    <Box className={styles.btn_container}>
                                        <Button variant='contained' className={styles.review_btn} onClick={handlePost} disabled={loading}>Submit</Button>
                                    </Box>
                                </Box>
                            </Box>

                            <Box className={styles.settings_body} sx={{ marginTop: '20px' }}>
                                <Box className={styles.wix_setting}>Layout Settings</Box>
                                <Box className={styles.wix_list} sx={{ padding: '20px' }}>
                                    <Box className={styles.file_post_container}>
                                        <InputLabel className={styles.post_label}>Layout</InputLabel>
                                        <Box sx={{ display: 'flex', alignItems: 'center', width: '85%' }}>
                                            <FormControlLabel
                                                control={
                                                    <Box
                                                        onClick={() => setLayoutEnabled(!layoutEnabled)}
                                                        sx={{
                                                            position: 'relative',
                                                            width: '44px',
                                                            height: '24px',
                                                            borderRadius: '12px',
                                                            backgroundColor: layoutEnabled ? 'var(--primary)' : '#ccc',
                                                            cursor: 'pointer',
                                                            transition: 'background-color 0.3s',
                                                            marginRight: '10px'
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                position: 'absolute',
                                                                top: '2px',
                                                                left: layoutEnabled ? '22px' : '2px',
                                                                width: '20px',
                                                                height: '20px',
                                                                borderRadius: '50%',
                                                                backgroundColor: '#fff',
                                                                transition: 'left 0.3s',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                                            }}
                                                        />
                                                    </Box>
                                                }
                                                label={
                                                    <Typography sx={{ fontSize: '14px', color: '#666' }}>
                                                        {layoutEnabled ? 'Enabled' : 'Disabled'}
                                                    </Typography>
                                                }
                                            />
                                        </Box>
                                    </Box>

                                    {layoutEnabled && (
                                        <>
                                            <Box className={styles.file_post_container}>
                                                <InputLabel className={styles.post_label}>Header</InputLabel>
                                                <Box
                                                    sx={{
                                                        width: '85%',
                                                        border: '1px solid #E6E7E9',
                                                        borderRadius: '4px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        overflow: 'hidden',
                                                        position: 'relative',
                                                        '&:hover': {
                                                            borderColor: 'var(--primary)',
                                                        }
                                                    }}
                                                >
                                                    <Button
                                                        component="label"
                                                        sx={{
                                                            textTransform: 'none',
                                                            borderRadius: 0,
                                                            backgroundColor: '#f0f7ff',
                                                            color: '#1976d2',
                                                            fontSize: '14px',
                                                            fontWeight: 600,
                                                            padding: '8px 16px',
                                                            minWidth: 'auto',
                                                            '&:hover': {
                                                                backgroundColor: '#e3f2fd',
                                                            }
                                                        }}
                                                    >
                                                        Choose File
                                                        <input
                                                            type="file"
                                                            hidden
                                                            onChange={(e) => setHeaderFile(e.target.files[0])}
                                                        />
                                                    </Button>
                                                    <Typography sx={{ px: 2, fontSize: '14px', color: '#666', flex: 1 }}>
                                                        {headerFile ? headerFile.name : 'No file chosen'}
                                                    </Typography>
                                                    {headerFile && (
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => setHeaderFile(null)}
                                                            sx={{
                                                                marginRight: '8px',
                                                                padding: '4px',
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                                                }
                                                            }}
                                                        >
                                                            <CloseIcon sx={{ fontSize: '18px', color: '#666' }} />
                                                        </IconButton>
                                                    )}
                                                </Box>
                                            </Box>

                                            <Box className={styles.file_post_container}>
                                                <InputLabel className={styles.post_label}>Footer</InputLabel>
                                                <Box
                                                    sx={{
                                                        width: '85%',
                                                        border: '1px solid #E6E7E9',
                                                        borderRadius: '4px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        overflow: 'hidden',
                                                        position: 'relative',
                                                        '&:hover': {
                                                            borderColor: 'var(--primary)',
                                                        }
                                                    }}
                                                >
                                                    <Button
                                                        component="label"
                                                        sx={{
                                                            textTransform: 'none',
                                                            borderRadius: 0,
                                                            backgroundColor: '#f0f7ff',
                                                            color: '#1976d2',
                                                            fontSize: '14px',
                                                            fontWeight: 600,
                                                            padding: '8px 16px',
                                                            minWidth: 'auto',
                                                            '&:hover': {
                                                                backgroundColor: '#e3f2fd',
                                                            }
                                                        }}
                                                    >
                                                        Choose File
                                                        <input
                                                            type="file"
                                                            hidden
                                                            onChange={(e) => setFooterFile(e.target.files[0])}
                                                        />
                                                    </Button>
                                                    <Typography sx={{ px: 2, fontSize: '14px', color: '#666', flex: 1 }}>
                                                        {footerFile ? footerFile.name : 'No file chosen'}
                                                    </Typography>
                                                    {footerFile && (
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => setFooterFile(null)}
                                                            sx={{
                                                                marginRight: '8px',
                                                                padding: '4px',
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                                                }
                                                            }}
                                                        >
                                                            <CloseIcon sx={{ fontSize: '18px', color: '#666' }} />
                                                        </IconButton>
                                                    )}
                                                </Box>
                                            </Box>
                                        </>
                                    )}

                                    <Box className={styles.btn_container}>
                                        <Button variant='contained' className={styles.review_btn} onClick={handlePost} disabled={loading}>Submit</Button>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>

                </Box> : <Skeleton sx={{ bgcolor: 'rgba(189,197,209,.2)', margin: '10px' }} animation="wave" variant="rounded" width={'calc(100% - 20px)'} height={'calc(100vh - 80px)'} />}
        </>
    );
};

export default Settings;